import React, { useState, useEffect } from 'react';
import TraderBroLogo from '../assets/traderbro-logo.svg';

const STATS = [
  '100+ Analysts Tracked',
  '3,000+ Predictions Scored',
  'Real Data. Real Results.',
];

export default function DemoClosingPage() {
  const [go, setGo] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setGo(true), 60);
    return () => clearTimeout(id);
  }, []);

  const base = 'transition-all duration-500 ease-out';

  const fade = (delay, fromCls = '', toCls = '') => ({
    className: `${base} ${go ? `opacity-100 ${toCls}` : `opacity-0 ${fromCls}`}`,
    style: { transitionDelay: go ? `${delay}ms` : '0ms' },
  });

  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center relative overflow-hidden select-none"
      style={{ background: '#FFFFFF', fontFamily: 'Inter, system-ui, sans-serif' }}
    >
      {/* Subtle dot-grid texture */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(rgba(0,0,0,0.045) 1px, transparent 1px)',
          backgroundSize: '28px 28px',
        }}
      />

      {/* Content stack — explicit margins keep spacing intentional */}
      <div className="relative z-10 flex flex-col items-center text-center px-8 max-w-2xl w-full">

        {/* Logo */}
        <div {...fade(300)} style={{ ...fade(300).style, marginBottom: '2rem' }}>
          <img
            src={TraderBroLogo}
            alt="TraderBro"
            className="h-12 w-auto"
            style={{ filter: 'brightness(0)' }}
          />
        </div>

        {/* Tagline */}
        <p
          {...fade(500, 'translate-y-3', 'translate-y-0')}
          style={{
            ...fade(500, 'translate-y-3', 'translate-y-0').style,
            fontSize: '1.125rem',
            fontWeight: 500,
            color: '#5A6072',
            letterSpacing: '-0.01em',
            lineHeight: 1.5,
            marginBottom: '2rem',
          }}
        >
          The Credit Score for Financial Influencers
        </p>

        {/* URL — hero moment */}
        <div
          {...fade(800, 'scale-[0.95]', 'scale-100')}
          style={{ ...fade(800, 'scale-[0.95]', 'scale-100').style, marginBottom: '2rem' }}
        >
          <span
            className={go ? 'demo-url-glow' : ''}
            style={{
              fontSize: 'clamp(2.75rem, 6vw, 4.5rem)',
              fontWeight: 900,
              color: '#2563EB',
              letterSpacing: '-0.03em',
              lineHeight: 1,
              display: 'block',
            }}
          >
            traderbro.ai
          </span>
        </div>

        {/* CTA line */}
        <p
          {...fade(1100, 'translate-y-2', 'translate-y-0')}
          style={{
            ...fade(1100, 'translate-y-2', 'translate-y-0').style,
            fontSize: '1rem',
            fontWeight: 400,
            color: '#5A6072',
            letterSpacing: '0.01em',
            marginBottom: '2.75rem',  /* more breathing room before pills */
          }}
        >
          Available now — try it free
        </p>

        {/* Stat pills — nowrap enforces single row */}
        <div
          {...fade(1400)}
          className={fade(1400).className}
          style={{
            ...fade(1400).style,
            display: 'flex',
            flexWrap: 'nowrap',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.75rem',
          }}
        >
          {STATS.map((s, i) => (
            <span
              key={i}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                fontSize: '0.75rem',      /* 12px — fits all 3 on one line */
                fontWeight: 600,
                color: '#374151',
                background: '#F3F4F6',
                border: '1px solid #E5E7EB',
                borderRadius: '99px',
                padding: '6px 14px',
                letterSpacing: '0.01em',
                whiteSpace: 'nowrap',
              }}
            >
              {s}
            </span>
          ))}
        </div>

      </div>

      {/* Scoped URL glow animation */}
      <style>{`
        @keyframes demo-url-breathe {
          0%, 100% {
            text-shadow:
              0 0 20px rgba(37, 99, 235, 0.12),
              0 0 40px rgba(37, 99, 235, 0.06);
          }
          50% {
            text-shadow:
              0 0 28px rgba(37, 99, 235, 0.38),
              0 0 56px rgba(37, 99, 235, 0.18),
              0 0 80px rgba(37, 99, 235, 0.06);
          }
        }
        .demo-url-glow {
          animation: demo-url-breathe 2s ease-in-out infinite;
          animation-delay: 1.6s;
        }
      `}</style>
    </div>
  );
}
